<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'clients') {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Clients
          @if (canExportCsv) {
            <button class="btn btn-sm btn-outline-secondary float-end hide-print" (click)="search(0, true)">
              <i class="fa fa-download"></i> Export CSV
            </button>
          }
        </h4>
        <div class="card-body">
          <h5 class="filters">Filters</h5>
          <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="search()">
            <div class="row">
              <div class="form-group col-md-3">
                <label>Name</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': name }" name="name" [(ngModel)]="name" (change)="search()" placeholder="eg: Bayer">
              </div>
              <div class="form-group col-md-3">
                <label>Topic</label>
                <select class="form-control" name="cluster" [(ngModel)]="cluster" (change)="search()">
                  <option value="">All</option>
                  @for (c of clusters; track c) {
                    <option [value]="c">{{c}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Category</label>
                <select class="form-control" name="category" [(ngModel)]="category" (change)="search()">
                  <option value="">All</option>
                  @for (c of categories; track c) {
                    <option [value]="c">{{c}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Status</label>
                <select class="form-control" name="active" [(ngModel)]="active" (change)="search()">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                  <option value="">All</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Services</label>
                <select class="form-control" name="contract" [(ngModel)]="contract" (change)="search()">
                  <option value="">All</option>
                  @for (c of contracts; track c) {
                    <option [value]="c">{{c}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Notes</label>
                <input type="text" class="form-control" name="notes" [ngClass]="{ 'is-touched': notes }" [(ngModel)]="notes" (change)="search()" placeholder="eg: Notes">
              </div>
            </div>
          </form>
          <hr>
          @if (isLoading.clients) {
            <p>
              <app-spinner [condition]="isLoading.clients"></app-spinner>
            </p>
          }
          @if (!isLoading.clients && clients?.length === 0) {
            <p>Nothing found.</p>
          }
          @if (isSearching && !isLoading.clients && clients?.length) {
            <p>
              <span class="badge badge-primary">{{count}}</span> results found:
            </p>
          }
          <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3" [ngClass]="{ 'disabled': isLoading.clients }">
            @for (client of clients; track client) {
              <div class="col mb-3">
                <app-client [client]="client"></app-client>
              </div>
            }
          </div>
          @if (clients?.length) {
            <app-pagination [isLoading]="isLoading.clients" [count]="count" [perPage]="perPage" [page]="page" eventName="getClients"></app-pagination>
          }
        </div>
      </div>
    }
    @if (currentContent === 'add-new-client' && !clientAdded) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Clients &raquo; Add new
        </h4>
        <div class="card-body">
          <app-add-client-form></app-add-client-form>
        </div>
      </div>
    }
    @if (currentContent === 'add-new-client' && clientAdded) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Clients &raquo; Add new
        </h4>
        <div class="card-body">
          <p>Client added successfully!</p>
          <a class="nav-link" [routerLink]="" (click)="currentContent = 'clients'; clientAdded = false">
            <i class="fa fa-list"></i> Go to clients page
          </a>
        </div>
      </div>
    }
  </div>

</div>
